import {createContext} from 'react'
import {getApi} from "@/utils/request";
import {getAccountList} from "@/services/accountApi";
import {getMessageStatus} from "@/services/homeApi";
import {message} from "antd";

export const LayoutContext = createContext('')

// 获取账户列表
export const fetchAccountList = async()=>{
    try {
        const data = await getApi({ api: getAccountList });
        return data?.map(item => ({
            ...item,
            label: item.name,
            value: item.account,
        }))
    } catch (error) {
        console.error("获取账户列表失败:", error);
    }
}

// 获取站内全部数据状态
export const getAllStatus = async (setInitialState) => {
    try {
        const response = await getMessageStatus();
        if (response.status){
            setInitialState((prevState) => {
                if (!prevState) return prevState;
                return {
                    ...prevState,
                    currentUser: {
                        ...(prevState.currentUser || {}),
                        messageAllStatus: response.data
                    },
                };
            });
        } else {
            message.error('操作失败，请重试');
        }
    } catch (error) {
        console.error(error);
        message.error(`操作失败:${error}`);
    }
}
